export default __webpack_public_path__ + "static/media/icon-bottom-nav-home.f540b896.svg";